// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#error-page{padding-top:50px;margin:0 auto;padding-bottom:50px}.error-content{max-width:1200px;background:#fff;margin:0 auto;padding:20px;text-align:center}.error-content h2{font-weight:700;font-size:35px;margin:20px}.error-content p{margin:8px 0}.error-content .col-md-8{text-align:left}.error-content .col-md-4{text-align:right}@media screen and (max-width:1000px){.error-content .col-md-4,.error-content .col-md-8{width:100%!important;max-width:100%;flex:none;text-align:left}}", ""]);
// Exports
module.exports = exports;
